self.__eclipse$config = {
	prefix: "/eclipse/",
	codec: self.__eclipse$codecs.xor,
	codecs: "/eclipse/eclipse.codecs.js",
	config: "/eclipse/eclipse.config.js",
	rewrite: "/eclipse/eclipse.rewrite.js",
	worker: "/eclipse/eclipse.worker.js",
	client: "/eclipse/eclipse.client.js",
};
